import languages from './languages.json'
export const languagesMixin = {
  data () {
    return {
      getLanguageNames: null
    }
  },
  created () {
    this.getLanguageNames = languages.map(element => element.language)
  },
  methods: {
    getFilteredLanguages (text) {
      this.filteredLanguages = this.getLanguageNames.filter((option) => {
        return option.toString().toLowerCase().indexOf(text.toLowerCase()) >= 0
      })
    }
  }
}
